import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { blackListLogWithdrawalsStore, } from "../stores/blackListLogWithdrawals";
import { useLocation } from "react-router-dom";
/* ------- */

class BlackListLogWithdrawals extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.Interface.loadBlackListLogWithdrawals("rejected");
	}

	handleKeyPress = (event) => {
		if (event.detail.key === "Enter") {
			setTimeout(() => {
				this.props.Interface.loadBlackListLogWithdrawals("rejected");
			}, 0);
		}
	};

	handleInputDebounceChange = (input) => {
		this.props.setBlackListLogWithdrawals({ ...this.props.blackListLogWithdrawals, currentSearch: input.detail.value, pagination: {
				...this.props.blackListLogWithdrawals.pagination,
				current: 1,
	 }});


		if (input.detail.value.length === 0) {
			setTimeout(() => this.props.Interface.loadBlackListLogWithdrawals("rejected"), 250)
		}

	};


	render() {
		return (
			<>
				{this.props.blackListLogWithdrawals.loaded && this.props.blackListLogWithdrawals.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.blackListLogWithdrawals.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.blackListLogWithdrawals.error.code} | request timestamp: {this.props.blackListLogWithdrawals.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.blackListLogWithdrawals.loaded}
					sortingColumn={{ sortingField: this.props.blackListLogWithdrawals.sorting.sortingColumn.column }}
					sortingDescending={this.props.blackListLogWithdrawals.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setBlackListLogWithdrawals({ ...this.props.blackListLogWithdrawals, sorting: {
								...this.props.blackListLogWithdrawals.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField
								},
								isDescending: sorting.detail.isDescending,
							} });

						setTimeout(() => {
							this.props.Interface.loadBlackListLogWithdrawals("rejected");
						}, 250);
					}}
					columnDefinitions={[
						{
							id: "id",
							header: "ID",
							sortingField: "id",
							cell: (item) => (
								item.id
							),
						},
						{ id: "withdrawalID", header: "Withdrawal id", sortingField: "withdrawalID", cell: (item) => item.withdrawalID },
						{ id: "uid", header: "UID", sortingField: "uid", cell: (item) => item.uid },
						{ id: "project", header: "Project", sortingField: "project", cell: (item) => item.project },
						{ id: "status", header: "Status", sortingField: "status", cell: (item) => item.status },
						{ id: "date", header: "Date", sortingField: "date", cell: (item) => <>{new Date(item.date).toLocaleDateString() + " " + new Date(item.date).toLocaleTimeString()}</> },
					]}
					items={this.props.blackListLogWithdrawals.data}
					pagination={
						<Pagination
							disabled={!this.props.blackListLogWithdrawals.loaded}
							currentPageIndex={this.props.blackListLogWithdrawals.pagination.current}
							pagesCount={this.props.blackListLogWithdrawals.pagination.total}
							onChange={(page) => {
								this.props.setBlackListLogWithdrawals({ ...this.props.blackListLogWithdrawals, pagination: { ...this.props.blackListLogWithdrawals.pagination, current: page.detail.currentPageIndex } });
								setTimeout(() => this.props.Interface.loadBlackListLogWithdrawals("rejected"), 250);
							}}
						/>
					}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Logs per page", options: this.props.config.blackListLogWithdrawals.preferences.perPage }}
							preferences={{ pageSize: this.props.config.blackListLogWithdrawals.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("players.blackListWithdrawals.perPage", preferences.detail.pageSize);
								this.props.setConfig({ ...this.props.config, blackListLogWithdrawals: { ...this.props.config.blackListLogWithdrawals, perPage: preferences.detail.pageSize } });

								setTimeout(() => this.props.Interface.loadBlackListLogWithdrawals("rejected"), 250);
							}}
						/>
					}
					filter={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Grid
									gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
									children={
										<>
											<Select
												filteringType="auto"
												disabled={!this.props.blackListLogWithdrawals.loaded}
												placeholder="Type"
												selectedOption={this.props.blackListLogWithdrawals.currentOption.type}
												onChange={(option) => {
													option.detail.selectedOption.type !== this.props.blackListLogWithdrawals.currentSearchType && this.props.setBlackListLogWithdrawals({ ...this.props.blackListLogWithdrawals, currentSearchType: option.detail.selectedOption.type, currentOption: { ...this.props.blackListLogWithdrawals.currentOption, type: option.detail.selectedOption } });
												}}
												options={this.props.config.blackListLogWithdrawals.options.type}
											/>
											<Input
												disabled={!this.props.blackListLogWithdrawals.loaded}
												onKeyDown={this.handleKeyPress}
												disableBrowserAutocorrect={true}
												placeholder="UID, withdrawal id, project"
												inputMode="search"
												type="search"
												value={this.props.blackListLogWithdrawals.currentSearch}
												onChange={this.handleInputDebounceChange}
											/>
										</>
									}
								/>
							}
						/>
					}
					header={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Header
									children="Black list log withdrawals"
									counter={
										<>
											(
											{
												this.props.blackListLogWithdrawals.pagination.count
											}
											)
										</>
									}
								/>
							}
						/>
					}
					empty="No black list withdrawals found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const blackListLogWithdrawals = useRecoilValue(blackListLogWithdrawalsStore);
		const setBlackListLogWithdrawals = useSetRecoilState(blackListLogWithdrawalsStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);

		return <Component {...props}  blackListLogWithdrawals={blackListLogWithdrawals} setBlackListLogWithdrawals={setBlackListLogWithdrawals} config={config} setConfig={setConfig}  />;
	};
}

export default withRecoil(BlackListLogWithdrawals);
